"use strict";
var _a;
exports.__esModule = true;
exports.getAuthBaseUrl = exports.SsoClientId = void 0;
var initBlizzard_1 = require("../initBlizzard");
var environment_1 = require("../environment");
var domain_1 = require("../config/domain");
var SsoClientId;
(function (SsoClientId) {
    SsoClientId["DESKTOP_WEB"] = "web-calling-corp--prod";
    SsoClientId["SNAPCHAT_COM"] = "snapchat-com-metrics";
})(SsoClientId = exports.SsoClientId || (exports.SsoClientId = {}));
var WEB_ANALYTICS_V2_ENDPOINT_SUFFIX = "/web-analytics-v2/web";
var clientIdRouteMap = (_a = {},
    _a[SsoClientId.DESKTOP_WEB] = {
        stagingUrl: domain_1.DWEB_STAGING_HOST + WEB_ANALYTICS_V2_ENDPOINT_SUFFIX,
        prodUrl: domain_1.DWEB_PROD_HOST + WEB_ANALYTICS_V2_ENDPOINT_SUFFIX
    },
    _a[SsoClientId.SNAPCHAT_COM] = {
        stagingUrl: "https://staging-gcp.api.snapchat.com" + WEB_ANALYTICS_V2_ENDPOINT_SUFFIX,
        prodUrl: "https://gcp.api.snapchat.com" + WEB_ANALYTICS_V2_ENDPOINT_SUFFIX
    },
    _a);
function getAuthBaseUrl(ssoClientId) {
    var route = clientIdRouteMap[ssoClientId];
    return (0, environment_1.getCollectionMode)() === initBlizzard_1.CollectionMode.STAGE ? route.stagingUrl : route.prodUrl;
}
exports.getAuthBaseUrl = getAuthBaseUrl;
//# sourceMappingURL=ssoClientConfig.js.map